import initSlider from '../libs/initSlider';
import changeActiveSlide from '../changeActiveSlide';
import { tabsSliderOptions, tabsContentSliderOptions } from '../sliders/sliders';

document.addEventListener('DOMContentLoaded', (e) => {
  const PAGE = 'crm';

  const crmPlansSlider = initSlider('[data-crm-plans-slider]', crmPlansSliderOptions);

  /*  */

  const salesTabsSlider = initSlider('[data-sales-tabs-slider]', tabsSliderOptions);
  const salesSlider = initSlider('[data-sales-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: salesTabsSlider,
      autoScrollOffset: 0.5,
    },
  });

  salesTabsSlider.on('click', (swiper) => {
    changeActiveSlide(swiper, PAGE);
  });
  salesSlider.on('slideChangeTransitionStart', (swiper) => {
    changeActiveSlide(swiper, PAGE);
  });

  /*  */

  const platformsTabsSlider = initSlider('[data-platforms-tabs-slider]', tabsSliderOptions);
  const platformsSlider = initSlider('[data-platforms-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: platformsTabsSlider,
      autoScrollOffset: 0.5,
    },
  });
});

const crmPlansSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 24,
  simulateTouch: false,

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  breakpoints: {
    768: {
      slidesPerView: 3,
    },
    601: {
      slidesPerView: 2,
    },
  },
};
